import http from "./HttpService";
import { getToken } from "../security/AppSecurity";


var endpoint = `system/log/application/errors`;
var telemetryEndpoint = `events-pwa/telemetry`;
var telemetryLookupEndpoint = `events-pwa/telemetry/lookups/applications`;
const getSystemErrors = async ({type, first, max, text = null}) => {
  var urlPath = `${endpoint}?appName=${type}&offset=${first}&limit=${max}`;

  if (text !== null && text !== undefined && text !== "") {
    urlPath += `&searchText=${text}`;
  }
  const response = await http.get(urlPath);
  return response;
};

const getErrorDetails = async (id) => {
  const response = await http.get(`${endpoint}/${id}`);
  return response;
};

const isKeyCloakConnected = async (address) => {

  try {
    const response = await http.head(address);
    if (response) return true;
  } catch (error) {
    console.log("Other error occurred:", error);

    ///FOR NOW SINCE THIS RESOLVES INTO AN ERROR EVEN WHEN THE SERVER IS UP
    ///RETURN AS TRUE FOR NOW UNTIL CORS HAS BEEN ADDED FOR CLIENT APP
    ///TO GET THE DESIRED BEHAVIOR CHANGE RETURN TO FALSE
    return true;
  }
};

export const sendTelemetry = async (payload, token = null) => {
  const resolvedToken = token || getToken?.();
  const config = resolvedToken
    ? {
      headers: {
        Authorization: `Bearer ${resolvedToken}`,
      },
    }
    : undefined;

  const response = http.post(`${telemetryEndpoint}`, payload, config);
  return response;
};

export const getTelemetryApplicationId = async (appName) => {
  const response = await http.get(`${telemetryLookupEndpoint}`);
  const records = Array.isArray(response?.data) ? response.data : [];

  const byName = records.find((item) => {
    const candidateName = item?.value;
    return (
      typeof candidateName === "string" &&
      candidateName.toLowerCase() === String(appName || "").toLowerCase()
    );
  });

  const selected = byName || records[0];
  const id = selected?.key;

  if (id == null) {
    return null;
  }

  const numericId = Number(id);
  return Number.isNaN(numericId) ? id : numericId;
};


const logServiceApi = {
  getSystemErrors,
  getErrorDetails,
  isKeyCloakConnected,
  sendTelemetry,
  getTelemetryApplicationId,
};

export default logServiceApi;
